import clsx from 'clsx'
import { Button, Col, Grid, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Recommendations/Audits/audits.module.scss'

const GroupActions = ({
  checkedIDsLength,
  archiveHandleClick,
  // checkboxHandleChange,
  // data,
  buttonLabel,
}) => {
  const { t } = useTranslation([])

  return (
    <div
      className={clsx(styles['recommendations-list__group-actions-slider'], {
        [styles['recommendations-list__group-actions-slider_active']]: checkedIDsLength > 0,
      })}
    >
      <Grid
        alignItems="center"
        justifyContent="between"
        className={styles['recommendations-list__group-actions-wrapper']}
      >
        {/*<Col className={styles['recommendations-list__group-actions-checkbox']}>*/}
        {/*  <Checkbox*/}
        {/*    className={styles['recommendations-list__checkbox']}*/}
        {/*    checked={checkedIDsLength === data.length}*/}
        {/*    onChangeHandle={checkboxHandleChange}*/}
        {/*  />*/}
        {/*</Col>*/}
        <Grid fluid={false} className={styles['recommendations-list__group-actions']}>
          <Button
            variant="primary"
            size="s"
            startIcon={<Icon inheritColor name="zip" size="s" />}
            onClick={archiveHandleClick}
          >
            {buttonLabel}
          </Button>
        </Grid>
        <Col className={styles['recommendations-list__group-actions-selected-accounts']}>
          {t('audits::group_actions.checkedAccounts', {
            count: checkedIDsLength,
          })}
        </Col>
      </Grid>
    </div>
  )
}

GroupActions.propTypes = {
  checkedIDsLength: PropTypes.number,
  archiveHandleClick: PropTypes.func,
  checkboxHandleChange: PropTypes.func,
  data: PropTypes.array,
  buttonLabel: PropTypes.string,
}
export default GroupActions
